import $ from 'jquery';
// import barba from '@barba/core';

export default function barbaInit() {

	// $('a[href^="'+ window.location.origin +'"]').click(function(e){
	// 	const _this = $(this);
	// 	e.preventDefault();
	// 	console.log(_this);
	// });

	let blank = $('.blankwhite');
	let parent = blank.parent();
	let clone = blank.clone();

	clone.css('display', 'none');
	clone.find('> .logo').css('display', 'none');
	clone.find('> .bg').css('display', 'none');

	parent.append(clone);

	setTimeout(()=>{
		blank.find('> .logo').fadeOut(200);
	}, 350);
	blank.find('> .bg').slideUp(1000, function(){
		blank.remove();
	});


	// if ($('#content > .landing').length) {
	// 	blank.addClass('is-closed');
	// 	blank.css('display', 'none');
	// } else {
	// 	blank.addClass('is-closed');
	//
	// 	setTimeout(()=>{
	// 		blank.css('display', 'none');
	// 	}, 1050);
	// }

	let arr = [];

	$('a[href^="' + window.location.origin + '"]').each(function (el) {
		let str = $(this).attr('href');

		if (str.indexOf('modal') === -1
			&& str.indexOf('#') !== 0
		) {
			arr.push(this);
		}
	});

	arr.forEach((el) => {
		$(el).click(function (e) {
			if (e.metaKey) {
				return true;
			}

			e.preventDefault();

			let _this = $(this);
			let url = _this.attr('href');

			// clone.slideDown(400);
			clone.css('display', '');

			setTimeout(()=>{
				clone.find('> .logo').fadeIn(200);
			}, 350);
			clone.find('> .bg').slideDown(1000);

			// blank.css('display', '');

			// setTimeout(()=>{
			// 	blank.removeClass('is-closed');
			// }, 50);

			setTimeout(function () {
				window.location.href = url;
			}, 1010);
		});
	});

	// barba.init({
	// 	transitions: [{
	// 		leave({current, next, trigger}) {
	// 			// do something with `current.container` for your leave transition
	// 			// then return a promise or use `this.async()`
	// 			this.async();
	// 		},
	// 		enter({current, next, trigger}) {
	// 			// do something with `next.container` for your enter transition
	// 			// then return a promise or use `this.async()`
	// 			this.async();
	// 		}
	// 	}]
	// });
}



// WEBPACK FOOTER //
// ./source/scripts/barba.js